import { illustrationForSeed } from '@/lib/illustrations';

/**
 * Which picture stands in for a search group.
 *
 * A group has no type and no cover of its own, so the pick is seeded on its id
 * and nothing else — stable across renders and sessions, and unchanged when the
 * groups list is reordered.
 *
 * It deliberately does *not* reach for the group's `cover_photos`: those are
 * photographs of houses the group is considering, and putting one behind the
 * hero would read as "this is your home" for a decision nobody has made yet.
 */
export function groupIllustration(group: Pick<{ id: string }, 'id'>): string | undefined {
    return illustrationForSeed(group.id);
}
